export default "__VITE_ASSET__CyLlZUiF__"